module.exports = __webpack_public_path__ + "static/media/hall-antolini.5eb10239.svg";